import { CfImageIconProps, ImageIconProps } from "../types";
import { convertCfBackgroundColorProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfColorProps } from "utilities/cfPropTypes/cfColor";
import ImageIcon from "..";
import React from "react";

export const convertCfImageIconProps = ({
  iconType,
  svgLibrary,
  svgColor,
  svgBackground,
  svgTypeImage = false,
  imageFile,
  alt,
  customClass,
}: CfImageIconProps) => {
  const props: ImageIconProps = {
    customClass,
    iconType,
    svgLibrary,
    svgColor: convertCfColorProps(svgColor),
    svgBackground: convertCfBackgroundColorProps(svgBackground),
    svgTypeImage,
    image:
      imageFile && iconType === "image"
        ? {
            imageDesktop: imageFile.file.url,
            alt: alt ?? "",
          }
        : null,
  };
  return props;
};

const CfImageIcon = (props: CfImageIconProps) => {
  return <ImageIcon {...convertCfImageIconProps(props)} />;
};

export default CfImageIcon;
